import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const userListStyles = makeStyles((theme: Theme) =>
    createStyles({
        list: {
            maxHeight: "300px",
            overflowY: "scroll",
            marginBottom: "15px",
        },

        listItem: {
            padding: 0,
            paddingLeft: 16,

            "& .MuiListItemIcon-root": {
                minWidth: "initial",
            },

            "& .MuiIconButton-root": {
                padding: "5px",
            },
        },
    })
);
